import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { MobileReservationResolverMobileReservationsRequested } from '../stores/mobilereservation/mobilereservation.actions';
import { RoomResolverRoomSelected } from '../stores/rooms/rooms.actions';

@Injectable({ providedIn: 'root' })
export class RoomResolverService {
  private readonly store = inject(Store);

  resolve(route: ActivatedRouteSnapshot): boolean {
    if (!route.parent?.params.location || !route.params.room) {
      return false;
    }

    this.store.dispatch(
      new RoomResolverRoomSelected({
        HotelCode: route.parent.params.location,
        Room: route.params.room,
      })
    );

    this.store.dispatch(
      new MobileReservationResolverMobileReservationsRequested({
        hotelCode: route.parent.params.location,
        unitCode: route.params.room,
      })
    );

    return true;
  }
}
